import { render, staticRenderFns } from "./MobileRedEnvelope.vue?vue&type=template&id=57d71d14&"
import script from "./MobileRedEnvelope.vue?vue&type=script&lang=js&"
export * from "./MobileRedEnvelope.vue?vue&type=script&lang=js&"
import style0 from "./MobileRedEnvelope.vue?vue&type=style&index=0&id=57d71d14&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports